module.exports = new __parcel__URL__("portal-2.9ec1b515.jpg").toString();